import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/antpsicologicos";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllAntpsicologicosByTax(params.tratamientoId);
}

export function AntpsicologicosList(props) {
  const [antpsicologicosList, setAntpsicologicos] = useState([]);
  let { tratamientoId } = useParams();
  let lastItem;

  useEffect(() => {
    API.getAllAntpsicologicosByTax(props.id).then(setAntpsicologicos).catch(console.log);
  }, [props.id]);

  return (
    <>
      {antpsicologicosList?.length ? (
        <ul className="entrenamiento cpt-list">
            {antpsicologicosList
              .sort((a, b) => {
                // Convertir las fechas a objetos de fecha para comparar
                const dateA = new Date(a.meta.metaFecha);
                const dateB = new Date(b.meta.metaFecha);
                // Ordenar de manera descendente (más reciente primero)
                return dateB - dateA;
              })
              .map((antpsicologicos) => (
                <li key={antpsicologicos.id}>
                  <NavLink className="capitalize" to={`${props.id}/antecedentes/psicologicos/${antpsicologicos.id}`}>
                  {`${FormatDate(antpsicologicos.meta.metaFecha)} - ${antpsicologicos.meta.antpsicTipo !== 'Valoración' ? 'Ingreso' : 'Valoración'}`}
                  </NavLink>
                </li>
              ))}
          </ul>
          ) : (
            <></>
          )}
    </>
  );
}



export function AntpsicologicosListContent(props) {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>Antecedentes Psicológicos</h1>
      </div>
      <div id="actions">
      {(props.userRole.includes('administrador') || props.userRole.includes('psicologia')) && (
        <Link className="button is-link" to={`new`}>Nuevo</Link>
      )}
      </div>
    </>
  );
}